<div class="py-20 flex justify-center">
  <span class="font-bold text-5xl text-slate-700">Terminal Gif Maker</span>
</div>
